import React from 'react';
import styles from './DescEditor.module.scss';
import LxEditor from '@web-common/components/UI/LxEditor/LxEditor';
const tinyStyle = 'body {margin: 0; font-size: 12px;}';
export const DescEditor = ({ originContent, disabled = false, isWarn = false, getEditorInstance, editorChange, editorBlur }) => {
    let content = originContent;
    const classDesc = `desc-editor ${isWarn ? styles.descEditorLimit : ''}`;
    const init = {
        setup: ed => {
            ed.on('blur', () => {
                editorBlur();
            });
        },
        init_instance_callback: ed => {
            getEditorInstance(ed);
        },
        paste_data_images: false,
        paste_remove_styles_if_webkit: false,
        paste_enable_default_filters: false,
        paste_preprocess: (plugin, args) => {
            var _a;
            args.force = true;
            args.content = (_a = args.content) === null || _a === void 0 ? void 0 : _a.replaceAll(/<img([\w\W]+?)>/gi, '');
        },
        contextmenu: 'paste pastetext | link linkchecker',
        content_style: tinyStyle,
        toolbar: ['undo redo link bold italic underline fontsizeselect forecolor bullist numlist'],
        plugins: ['advlist autolink lists link print preview', 'searchreplace visualblocks nonbreaking lxsignature', 'media paste code wordcount'],
    };
    return React.createElement(LxEditor, { initialValue: content, uniqueClass: classDesc, init: init, disabled: disabled, onEditorChange: editorChange });
};
